import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
} from 'redux-persist';
import teamReducer from './team/slice';
import authReducer from './authenticate/slice';
import commonReducer from './common/slice';
import sheetsReducer from './sheets/slice';
import onboardingReducer from './onboarding/slice';
import clockReducer from './clock/slice';
import tasklistsReducer from './tasklists/slice';
import schedulesReducer from './schedules/slice';
import settingsReducer from './settings/slice';
import helpReducer from './help/slice';
import posReducer from './pos/slice';
import ordersReducer from './orders/slice';
import payrollReducer from './payroll/slice';
import dashboardReducer from './dashboard/slice';
import commissionsReducer from './commissions/slice';
import inventoryReducer from './inventory/slice';

const store = configureStore({
  reducer: {
    teamReducer,
    authReducer,
    commonReducer,
    sheetsReducer,
    onboardingReducer,
    clockReducer,
    tasklistsReducer,
    schedulesReducer,
    settingsReducer,
    helpReducer,
    posReducer,
    ordersReducer,
    payrollReducer,
    dashboardReducer,
    commissionsReducer,
    inventoryReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),

});

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export {
  store,
  persistor,
};
